export const SESSION_START = 'Session start';
export const ORDER_CREATED = 'Order created';
export const WITHDRAW_TRANSACTION_SEND = 'Withdraw transaction send';
export const DEPOSIT_TRANSACTION_SEND = 'Deposit transaction send';

export const CONNECT_WALLET_CLICK = 'Connect wallet click';
export const CHOOSE_WALLET_NETWORK = 'Choose wallet network';
export const CHOOSE_WALLET = 'Choose wallet';
export const WALLET_CONNECTED = 'Wallet connected';
export const CONNECT_WALLET_CANCELLED = 'Connect wallet cancelled';
export const CONNECT_WALLET_ERROR = 'Connect wallet error';
export const WALLET_ADDRESS_COPIED = 'Wallet address copied';
export const CHANGE_WALLET = 'Change wallet';
export const DISCONNECT_WALLET = 'Disconnect wallet';

export const NETWORK_CHANGED = 'Network changed';
export const TRY_TO_SWITCH_NETWORK = 'Try to switch network';
export const NETWORK_SWITCH_SUCCESS = 'Network switch success';
export const NETWORK_SWITCH_FAILED = 'Network switch failed';
export const NETWORK_SWITCH_CANCELLED = 'Network switch cancelled';

// Swap page events
export const PAIR_CHANGED = 'Pair changed';
export const FEE_CURRENCY_CHANGED = 'Fee currency changed';
export const EXACT_CHANGED = 'Exact changed';
export const SWAP = 'Swap';
export const SWAP_FILTER_USED = 'Swap filter used';
export const SWAP_CHART_CHANGE_SCALE = 'Swap chart change scale';
export const WENT_TO_SWAP_HISTORY = 'Went to swap history';
export const FILTER_SWAP_HISTORY = 'Filter swap history';
export const TRADE = 'Trade';

// Pool page events
export const POOL_SELECTED = 'Pool selected';
export const POOL_SEARCH = 'Pool search';
export const ADD_POOL_LIQUIDITY_INTENT = 'Add pool liquidity intent';
export const ADD_POOL_LIQUIDITY_SUPPLY = 'Add pool liquidity supply';
export const ADD_POOL_LIQUIDITY_REJECTED = 'Add pool liquidity rejected';
export const REMOVE_POOL_LIQUIDITY = 'Remove pool liquidity';
export const STAKE_LP_TOKENS = 'Stake LP tokens';
export const CLAIM_REWARD = 'Claim reward';
export const UNSTAKE_LP_TOKENS = 'Unstake LP tokens';
export const ADD_NEW_POOL = 'Add new pool';
export const CHOOSE_BASE_ASSET = 'Choose base asset';
export const CHOOSE_QUOTE_ASSET = 'Choose quote asset';
export const CANCEL_ADD_POOL = 'Cancel add pool';
export const SUBMIT_POOL = 'Submit pool';
export const TRY_MIGRATE = 'Try migrate';
export const APPROVE_MIGRATE_CONTRACT = 'Approve migrate contract';
export const MIGRATE_POOL = 'Migrate pool';
export const MIGRATION_SUCCESSFUL = 'Migration successful';
export const MIGRATION_FAILED = 'Migration failed';
export const UNSTAKE_MIGRATE_TOKENS = 'Unstake migrate tokens';

// REFERRAL EVENTS
export const REFERRAL_USED = 'Referral used';
export const REFERRAL_CONNECT_WALLET_CLICK = 'Ref welcome connect wallet click';
